<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="selectedUrl ? `` : `transaction/sibling`"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_clc_id_number" class="col-sm-3 mb-0">
						CLC ID Number
					</label>
					<app-input
						id="inputs_clc_id_number"
						class="col-sm-9"
						type="text"
						v-model="inputs.clc_id_number"
						placeholder="CLC ID Number"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_first_name" class="col-sm-3 mb-0">
						First Name
					</label>
					<app-input
						id="inputs_first_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.name"
						placeholder="First Name"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_surname" class="col-sm-3 mb-0">
						Last Name
					</label>
					<app-input
						id="inputs_surname"
						class="col-sm-9"
						type="text"
						v-model="inputs.surname"
						placeholder="Last Name"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_status" class="col-sm-3 mb-0">
						Status
					</label>
					<app-input
						id="inputs_status"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_status"
						@input="setStatusValue"
						fetch-url="/master/lead-status?lead_status_id=null&per_page=50"
						:placeholder="'Status'"
						list-value-field="status"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_sub_status" class="col-sm-3 mb-0">
						Sub Status
					</label>
					<app-input
						id="inputs_sub_status"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_sub_status"
						@input="setSubStatusValue"
						:fetch-url="`/master/lead-status?lead_status_id=${input_status.id}&per_page=50`"
						:placeholder="'Sub Status'"
						list-value-field="status"
						:disabled="isInputStatusEmptyOrNoId"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_school_name" class="col-sm-3 mb-0">
						School Name
					</label>
					<app-input
						id="inputs_school_name"
						type="advance-search-select"
						class="col-sm-9"
						:loaded-per-time="10"
						v-model="input_school_name"
						@input="setSchoolId"
						fetch-url="master/school"
						placeholder="School Name"
						list-value-field="name"
						required
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_school_level" class="col-sm-3 mb-0">
						School Level
					</label>
					<app-input
						id="inputs_school_level"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_school_level"
						@input="setSchoolLevelId"
						fetch-url="master/school-level"
						placeholder="School Level"
						list-value-field="name"
						required
					/>
				</div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "SiblingInformationTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			modalId: this.formId,
			modalTitle: this.$t("add"),
			inputs: {
				sibling_clc_id_number: this.value?.clc_id_number || 0,
			},
			input_status: {},
			input_sub_status: {},
			input_school_name: {},
			input_school_level: {},
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
		setStatusValue(data) {
			this.inputs.status_id = this.inputs.status_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.status_id = data.id;
			}
		},
		setSubStatusValue(data) {
			this.inputs.sub_status_id = this.inputs.sub_status_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.sub_status_id = data.id;
			}
		},
		setSchoolId(data) {
			this.inputs.school_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.school_id = data.id;
			}
		},
		setSchoolLevelId(data) {
			this.inputs.school_level_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.school_level_id = data.id;
			}
		},
	},
	computed: {
		isInputStatusEmptyOrNoId() {
			return (
				Object.keys(this.input_status).length === 0 ||
				!this.input_status.hasOwnProperty("id") ||
				this.input_status.id === "" ||
				this.input_status.id === null ||
				this.input_status.id === 0
			);
		},
	},
};
</script>
